const MAPBOX_TOKEN =
  'pk.eyJ1IjoidGlvdGRldiIsImEiOiJjbGlvdTZnZTkwMm96M21uNWcxcG9hNmlpIn0.VKCE0hOvRMFPSOipLIMe2w';

// Static Mapbox image for a post location. Uses the "Worldmap TF Post
// Light/Dark" styles — copies of the old sidebar-map styles with pure
// white/black backgrounds, so the cards' multiply/screen blend modes turn
// the map background into exactly the card color. (The originals stay
// untouched for the production build still on the old design.)
// Returns undefined when the location has no coordinates.
export default function staticMapUrl(location, dark, width = 672, height = 300) {
  if (
    !location ||
    !location.countryCode ||
    !location.coordinates ||
    !location.coordinates.coordinates
  )
    return undefined;
  const [longitude, latitude] = location.coordinates.coordinates;
  const { bbox, countryCode } = location;
  if (bbox)
    return `https://api.mapbox.com/styles/v1/tiotdev/${
      dark ? 'cmq88zb6u005d01qx6qdnawt9' : 'cmq88yhl4000q01s5e7n5c114'
    }/static/pin-l+${
      dark ? '004D40' : '80CBC4'
    }(${longitude},${latitude})/${JSON.stringify(
      bbox,
    )}/${width}x${height}@2x?access_token=${MAPBOX_TOKEN}&setfilter=[%22!=%22,%22iso_3166_1%22,%22${countryCode.toUpperCase()}%22]&layer_id=admin-0-boundary&logo=false&attribution=false`;
  return `https://api.mapbox.com/styles/v1/mapbox/${
    dark ? 'dark' : 'light'
  }-v9/static/geojson(%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B${longitude}%2C${latitude}%5D%7D)/${longitude},${latitude},6/${width}x${height}@2x?access_token=${MAPBOX_TOKEN}&logo=false&attribution=false`;
}
